module.exports = __webpack_public_path__ + "img/linkedin.a0311520.svg";